import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SxProps,
} from "@mui/material";
import { Dispatch, MutableRefObject, SetStateAction, useEffect, useRef, useState } from "react";
import CustomTextField from "./CustomTextField";

// const incrementalSearchOptionLength = 10;
type Props = {
  open: boolean;
  onClose: () => void;
  onSearch: () => Promise<void>;
  isFastLoading?: MutableRefObject<boolean>;
  getMoreStockList?: Function;
  companyCd: string;
  companyName: string;
  centerCd: string;
  isLoading: boolean;
  setCompanyCd: Dispatch<SetStateAction<string>>;
  setCompanyName: Dispatch<SetStateAction<string>>;
  setCenterCd: Dispatch<SetStateAction<string>>;
};

const styles: { [key: string]: SxProps } = {
  searchRowBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
};

/**
 * 絞り込み検索モーダル
 * @param root0 コンポーネントのprops
 * @returns JSX.Element
 */
function SettingSearchDialog({
  open,
  isFastLoading,
  onClose,
  onSearch,
  getMoreStockList,
  companyCd,
  companyName,
  centerCd,
  isLoading,
  setCompanyCd,
  setCompanyName,
  setCenterCd,
}: Props) {
  const [getMoreLoadEvent, setGetMoreLoadEvent] = useState(false);
  const contentRef = useRef<HTMLDivElement | undefined>(undefined);
  const handleClose = () => {
    onClose();
  };
  const handleScroll = async () => {
    if (isFastLoading?.current || !contentRef.current) {
      return;
    }
    const scrollTop = contentRef.current?.scrollTop;
    const contentHeight = contentRef.current?.clientHeight;
    const scrollHeight = contentRef.current?.scrollHeight;
    if (scrollTop + contentHeight >= scrollHeight) {
      setGetMoreLoadEvent((prev) => !prev);
    }
  };
  useEffect(() => {
    (async () => {
      if (getMoreStockList) await getMoreStockList();
    })();
  }, [getMoreLoadEvent]);

  const searchElementRow = () => {
    const searchElement = [
      <Box key="companyCd" m={1} width="calc(50% - 16px)">
        <CustomTextField
          id="companyCd"
          type="text"
          label="企業コード"
          text={companyCd}
          setText={setCompanyCd}
          maxLength={6}
          size="small"
          isNumericText
        />
      </Box>,
      <Box key="companyName" m={1} width="calc(50% - 16px)">
        <CustomTextField
          id="companyCd"
          type="text"
          label="企業名"
          text={companyName}
          setText={setCompanyName}
          maxLength={100}
          size="small"
        />
      </Box>,
      <Box key="centerCd" m={1} width="calc(50% - 16px)">
        <CustomTextField
          id="centerCd"
          type="text"
          label="センターコード"
          text={centerCd}
          setText={setCenterCd}
          maxLength={50}
          size="small"
        />
      </Box>,
    ];
    const len = Math.ceil(searchElement.length / 2);
    const couples = [];
    for (let i = 0; i < len; i += 1) {
      const element1 = searchElement[i * 2];
      let element2: JSX.Element | undefined;
      if (i * 2 + 1 < searchElement.length) {
        element2 = searchElement[i * 2 + 1];
      }
      couples.push(
        <Box sx={styles.searchRowBox}>
          {element1}
          {element2 ?? <> </>}
        </Box>,
      );
    }

    return <Box>{couples}</Box>;
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <Box p={2}>
        <DialogTitle>絞り込み検索</DialogTitle>
        <DialogContent sx={{ overflow: "visible" }}>
          {isLoading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
              }}
            >
              <CircularProgress size={80} />
            </Box>
          )}
          {searchElementRow()}
        </DialogContent>
        <DialogActions>
          <Button variant="custom-outlined" onClick={handleClose}>
            キャンセル
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={async () => {
              onSearch();
              handleClose();
            }}
            disabled={isLoading}
          >
            {isLoading ? "検索中..." : "検索"}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default SettingSearchDialog;
